import { LazyModule } from 'owa-bundling-light';
import { networkFailureHandler } from './networkFailureHandler';
import type LazyAction from 'owa-bundling-light/lib/LazyAction';

/**
 * wraps the module in try/catch and shows a toast with network
 * error in case of lazy load failure
 * telemetry of network failure is handled internally by LazyAction
 */
export function lazyActionWithErrorHandler<
    TActionArgs extends any[],
    TModule extends LazyModule<any>
>(lazyAction: LazyAction<(...args: TActionArgs) => any, TModule>) {
    return async function (...actionArgs: TActionArgs) {
        lazyAction
            .import()
            .then(downloadedAction => downloadedAction(...actionArgs))
            .catch(networkFailureHandler);
    };
}
